import safeMerge from 'common/safeMerge';

import NerubArPalace from './nerubar-palace';

const spells = safeMerge(NerubArPalace);

export default spells;
